import { ReactElement } from 'react';
import ModalWrapper from '../../components/modals/ModalWrapper';
import { IonContent } from '@ionic/react';
import OrderMethod from '../../../../modals/order-method/OrderMethodModal';

const OrderMethodModal = (): ReactElement => {
  return (
    <ModalWrapper>
      <IonContent className="min-h-[90dvh]">
        <OrderMethod />
      </IonContent>
    </ModalWrapper>
  );
};

export default OrderMethodModal;
